import { useMutation } from '@tanstack/react-query'

import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'

import { TCreateInfoParamsType } from './type'
import { APIInstance } from '@/utils/functions/instance'

export function useCreateInfo({
  disableToast,
  ...rest
}: IApiBaseTypes<TCreateInfoParamsType> = {}) {
  return useMutation({
    mutationFn: async (payload: TCreateInfoParamsType) =>
      await APIInstance<IResponseType<{}>>({
        url: 'mrf/personal-info/',
        method: 'post',
        data: payload
      }),
    retry: 0,
    mutationKey: ['createPersonalInfo'],
    ...rest
  })
}
